import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserAppResource from "./UserAppResource";

export const TYPE_CITY = 'City';
export const TYPE_ZIP = 'Zip';

class ServiceAreaAppResource extends AppResource {
  /**
   * @returns {string}
   */
  appResourceType() {
    return 'service-areas';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'services/areas';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'userUuid',
      'createdAt',
      'city',
      'state',
      'type',
      'deliveryLine',
      'zip',
      'coordinates',
      'user',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      user: UserAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      user: 'user_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      userUuid: {
        type: 'string',
        presence: true,
      },
      city: {
        type: 'string',
        presence: true,
      },
      state: {
        type: 'string',
        presence: true,
        length: {
          minimum: 2,
          maximum: 2,
        },
      },
      type: {
        type: 'string',
        presence: true,
      },
      deliveryLine: {
        type: 'string',
      },
      zip: {
        type: 'string',
        length: {
          maximum: 10,
        },
      },
      coordinates: {},
    };
  }

}

export default ServiceAreaAppResource;
